<template>
  <div v-if="model != null" class="action_air_condititon">
    <template v-if="model.ValueType == 'UIControl_AC_Temperature'">
      <span v-if="noLable && model.Name" class="scence_ctr_span_title">{{
        model.Name
      }}</span>
      <div class="scence_ctr_div">
        <div class="conditioner_plane">
          <div class="conditioner_temperature">
            <div>
              <div class="fl-center">
                <img
                  class="button"
                  src="../../assets/img/ota/buttonL.png"
                  @click="
                    conditionerSetTemperature('-', model);
                    doCallAction.apply(this, [...doCallparam,model.DefaultValue,'',model]);
                  "
                >
              </div>
              <div class="fl-center">
                <el-input-number
                  v-model="model.DefaultValue"
                  :step="1"
                  :min="model.Min"
                  :max="model.Max"
                  style="width: 60px"
                  @change="doCallAction.apply(this, [...doCallparam,model.DefaultValue,'',model])"
                />
              </div>
              <div>°C</div>
              <div class="fl-center">
                <img
                  class="button"
                  src="../../assets/img/ota/buttonR.png"
                  @click="
                    conditionerSetTemperature('+', model);
                    doCallAction.apply(this, [...doCallparam,model.DefaultValue,'',model]);
                  "
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="model.ValueType == 'UIControl_AC_Speed'">
      <span
        v-if="noLable && model.Name"
        class="scence_ctr_span_title"
      >{{ model.Name }}</span>
      <div class="scence_ctr_div">
        <el-radio-group
          v-model="model.DefaultValue"
          size="mini"
          class="conditioner_wind"
          @change="doCallAction.apply(this,[...doCallparam,model.DefaultValue,'',model])"
        >
          <el-radio-button
            v-for="(smodel, i) in model.EnumValue"
            :key="'Temp' + smodel.Value"
            :label="smodel.Value"
            border
          >
            {{ smodel.Name }}
          </el-radio-button>
        </el-radio-group>
      </div>
    </template>
    <template v-else-if="model.ValueType == 'UIControl_AC_Mode'">
      <span v-if="noLable && model.Name" class="scence_ctr_span_title">{{
        model.Name
      }}</span>
      <div class="scence_ctr_div">
        <el-radio-group
          v-model="model.DefaultValue"
          size="mini"
          class="conditioner_wind"
          style="margin-bottom: 18px"
          @change="doCallAction.apply(this, [...doCallparam,model.DefaultValue,'',model])"
        >
          <el-radio
            v-for="(smodel, i) in model.EnumValue"
            :key="'Mode' + smodel.Value"
            :label="smodel.Value"
            border
          >
            <template v-if="model.DefaultValue == smodel.Value">
              <template v-if="smodel.Value == 0">
                <img src="../../assets/img/ota/auto-clicked.png">
              </template>
              <template v-if="smodel.Value == 1">
                <img src="../../assets/img/ota/lengfeng-clicked.png">
              </template>
              <template v-if="smodel.Value == 2">
                <img src="../../assets/img/ota/nuanfeng-clicked.png">
              </template>
              <template v-if="smodel.Value == 3">
                <img src="../../assets/img/ota/songfeng-clicked.png">
              </template>
              <template v-if="smodel.Value == 4">
                <img src="../../assets/img/ota/dehumidify-clicked.png">
              </template>
            </template>
            <template v-else>
              <template v-if="smodel.Value == 0">
                <img src="../../assets/img/ota/auto-def.png">
              </template>
              <template v-if="smodel.Value == 1">
                <img src="../../assets/img/ota/lengfeng-def.png">
              </template>
              <template v-if="smodel.Value == 2">
                <img src="../../assets/img/ota/nuanfeng-def.png">
              </template>
              <template v-if="smodel.Value == 3">
                <img src="../../assets/img/ota/songfeng-def.png">
              </template>
              <template v-if="smodel.Value == 4">
                <img src="../../assets/img/ota/dehumidify-def.png">
              </template>
            </template>
            <span>{{ smodel.Name }}</span>
          </el-radio>
        </el-radio-group>
      </div>
    </template>
    <template v-else-if="model.ValueType == 'UIControl_RadioboxList_VImage'">
      <span
        v-if="noLable && model.Name"
        class="scence_ctr_span_title"
      >{{ model.Name }}</span>
      <div class="scence_ctr_div">
        <el-radio-group
          v-model="model.DefaultValue"
          size="mini"
          class="conditioner_wind"
          style="margin-bottom: 18px;"
          @change="doCallAction.apply(this,[...doCallparam,model.DefaultValue,'',model])"
        >
          <el-radio
            v-for="(smodel, i) in model.EnumValue"
            :key="'Mode' + smodel.Value"
            :label="smodel.Value"
            border
          >
            <div
              class="mode-icon"
              :style="model.DefaultValue==smodel.Value?'background-color: #3F78F6':''"
            >
              <img
                class="mode-icon-img"
                :src="model.DefaultValue==smodel.Value?smodel.IconUrl.h:smodel.IconUrl.n"
              >
            </div>
            <span>{{ smodel.Name }}</span>
          </el-radio>
        </el-radio-group>
      </div>
    </template>
    <template v-else>
      <InnerText  :name="model.Name" :value="model.DefaultValue" :show-label="noLable" :showValue="false"  @click="doCallAction.apply(this, [...doCallparam,model.DefaultValue,'',model])"/>
    </template>
  </div>
</template>

<script>
import InnerText from '@/components/button/InnerText'
export default {
  name: 'ActionAirCondition',
  props: {
    model: {
			type: Object,
			default: null
    },
    doCallAction: {
      type: Function,
      default: null
    },
    ActionList: {
			type: Array,
			default: null
    },
    tem: {
			type: Object,
			default: null
    },
    doCallparam: {
      type: Array,
			default: []
    },
    noLable: {
      type: Boolean,
			default: false
    }
   },
   components: {
    InnerText
   },
   data () {
     return {
      //  activeState: this.active
     }
   },
   methods: {
  }
 }
</script>

<style lang="scss" scoped>
/* 	actionAirCondition 空调能力组件 */
.mode-icon{
  width: 30px;
  height:30px;
  border-radius: 50%;
  box-sizing: border-box;
  padding: 5px;
  &-img{
    width: 20px !important;
    height: 20px;
  }
}
.action_air_condititon{
  display: flex;
  flex-direction: row;
  align-items: center
  // align-items: baseline;
}
.scence_ctr_div{
  float: none;
}
</style>
